"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const whatsNewSlice_1 = require("../../../redux/slices/whatsNewSlice");
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const svgIcons_1 = require("../../../svgIcons");
require("./whatsNewPopup.scss");
class WhatsNewPopup extends react_1.Component {
    constructor() {
        super(...arguments);
        this.openFormModal = () => {
            this.props.togglePreview();
            this.props.toggleAddModal();
            this.props.toggleDetailsModal();
        };
        this.onPublish = () => {
            const { whatsNew: { editable } } = this.props;
            this.props.createWhatsNew(editable);
            this.props.resetWhatsNew();
        };
        this.close = () => {
            const { whatsNew: { singleWhatsNew }, adminView } = this.props;
            if (!adminView) {
                this.props.addUserWhatsNew({ w_new_id: singleWhatsNew.id });
            }
            this.props.toggleDetailsModal();
            setTimeout(() => {
                this.props.resetWhatsNew();
            }, 100);
        };
    }
    render() {
        const { whatsNew: { singleWhatsNew, editable, detailsModalOpen, preview }, adminView } = this.props;
        const item = preview ? editable : singleWhatsNew;
        return (item.title &&
            react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(core_1.Dialog, { className: "view-whats-new-modal", open: detailsModalOpen, fullWidth: true, maxWidth: 'sm', onClose: () => this.close() },
                    react_1.default.createElement(react_1.Fragment, null,
                        adminView && preview &&
                            react_1.default.createElement("label", { className: "edit-new", onClick: () => this.openFormModal() },
                                react_1.default.createElement(svgIcons_1.EditIcon, null),
                                react_1.default.createElement("span", null, "Edit")),
                        react_1.default.createElement(core_1.DialogContent, { className: "modal-body" },
                            react_1.default.createElement(core_1.Box, { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" },
                                react_1.default.createElement("span", { className: "tada-icon" }),
                                react_1.default.createElement("div", { className: "wn-title" }, item.title)),
                            react_1.default.createElement(core_1.Box, { className: "mt-20" }, Object.keys(item.subtitle).map(key => {
                                return (react_1.default.createElement("div", { key: key, className: "wn-subtitle" },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement(svgIcons_1.CheckIcon, null)),
                                    react_1.default.createElement("span", { className: "ml-10 " }, item.subtitle[key])));
                            })),
                            react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center", flexDirection: "column", className: "pt-20 mr-10 ml-10" },
                                adminView && preview && react_1.default.createElement(core_1.Button, { className: "pub", variant: "contained", color: "primary", onClick: () => this.onPublish() }, "Publish"),
                                !preview && react_1.default.createElement(core_1.Button, { variant: "contained", color: "primary", onClick: () => this.close() }, "OK, got it")))))));
    }
}
const mapStateToProps = (state) => {
    const { whatsNew } = state;
    return {
        whatsNew
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleDetailsModal: () => dispatch(whatsNewSlice_1.toggleDetailsModal()),
        toggleAddModal: () => dispatch(whatsNewSlice_1.toggleAddModal()),
        togglePreview: () => dispatch(whatsNewSlice_1.togglePreview()),
        createWhatsNew: (data) => dispatch(whatsNewSlice_1.createWhatsNew(data)),
        resetWhatsNew: () => dispatch(whatsNewSlice_1.resetWhatsNew()),
        addUserWhatsNew: (data) => dispatch(whatsNewSlice_1.addUserWhatsNew(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WhatsNewPopup);
